import { supabase } from '@/lib/supabase';

export type SessionAuditAction =
  | 'session_start'
  | 'session_end'
  | 'session_heartbeat'
  | 'session_device_change'
  | 'session_ip_change';

interface SessionAuditPayload {
  userId: string;
  sessionId: string | null;
  sessionToken?: string | null;
  action: SessionAuditAction;
  metadata?: Record<string, any>;
  isSuperadmin?: boolean;
  locationId?: string | null;
  performedAs?: string | null;
}

export async function logSessionAuditEvent({
  userId,
  sessionId,
  sessionToken,
  action,
  metadata,
  isSuperadmin,
  locationId,
  performedAs,
}: SessionAuditPayload): Promise<void> {
  try {
    await supabase.functions.invoke('session-audit', {
      body: {
        action,
        sessionId,
        sessionToken,
        metadata: {
          ...(metadata || {}),
          user_id: userId,
          is_superadmin_action: isSuperadmin ?? false,
          location_id: locationId ?? null,
          performed_as: performedAs ?? null,
        },
      },
    });
  } catch (error) {
    console.error('Failed to log session audit event:', error);
  }
}
